import { getPlan } from '../../@data-loaders/get-plan';
import type { Field } from '../../shared/interfaces';

export const product: Field = {
    feedback: false,
    // eslint-disable-next-line max-params-no-constructor/max-params-no-constructor
    async mutate(element, elements: any, publicConfig, options, form) {
        const planCode = elements.plan_code?.input?.value;
        if (!planCode) {
            throw new Error(`Missing plan_code. Make sure your url is correct or try another link.`);
        }

        const plan = await getPlan(`code-${planCode}`);
        const select = element.input as HTMLSelectElement;
        const metadataString = plan.custom_fields.find((field: { name: string }) => {
            return field.name === `metadata`;
        })?.value;

        if (!metadataString) {
            select.disabled = true;
            const option = document.createElement(`option`);
            option.label = `Plan not eligible for product selection.`;
            option.value = ``;
            select.options.add(option);
            return;
        }

        const metadata = JSON.parse(metadataString);
        const products: { label: string; sku: string }[][] | undefined = metadata.products;

        if (!products || products.length === 0) {
            select.disabled = true;
            const option = document.createElement(`option`);
            option.label = `Plan not eligible for product selection.`;
            option.value = ``;
            select.options.add(option);
            return;
        }

        // TODO: dynamically generate multiple product selects based on plan products lists
        products.forEach((productList) => {
            productList.forEach((productItem) => {
                const option = document.createElement(`option`);
                option.label = productItem.label;
                option.value = productItem.sku;
                select.options.add(option);
            });
        });

        if (select.options.length === 1) {
            select.disabled = true;
            return;
        }

        select.disabled = false;
    },
};
